import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ModalDialog from '../ModalDialog';
import { getPublicConfig } from '../../reducers';
import './_styles_/ContactsPopup.css';

ContactsPopup.propTypes = {
    onCancel: PropTypes.func.isRequired,
};

export const mapArrayToBreaks = (line, key) => (<React.Fragment key={key}>{line}<br /></React.Fragment>);

function ContactsPopup(props) {
    const {
        onCancel,
    } = props;
    const { t } = useTranslation();
    const { contacts } = useSelector(getPublicConfig);
    return (
        <ModalDialog onCancel={onCancel}>
            <div className="contacts-popup-dialog" role="dialog" aria-modal>
                <div className="contacts-popup-dialog--header">
                    <h4>{t('contacts.title')}</h4>
                    <button type="button" className="close-button button-small button-primary-text contacts-popup-dialog--close" onClick={onCancel}>
                        <span aria-label={t('button.x')} title={t('button.x')} role="img">
                            <FontAwesomeIcon icon="times" />
                        </span>
                    </button>
                </div>
                <table>
                    <tbody>
                        {contacts.companyName && (
                            <tr>
                                <td />
                                <td className="contacts-popup-dialog--company-name"><strong>{contacts.companyName}</strong></td>
                            </tr>
                        )}
                        {contacts.address && (
                            <tr>
                                <td>{t('contacts.address')}</td>
                                <td className="contacts-popup-dialog--address">{contacts.address.map(mapArrayToBreaks)}</td>
                            </tr>
                        )}
                        {contacts.phones && (
                            <tr>
                                <td>{t('contacts.phones')}</td>
                                <td className="contacts-popup-dialog--phones">{contacts.phones.join(', ')}</td>
                            </tr>
                        )}
                        {contacts.faxes && (
                            <tr>
                                <td>{t('contacts.faxes')}</td>
                                <td className="contacts-popup-dialog--faxes">{contacts.faxes.join(', ')}</td>
                            </tr>
                        )}
                        {contacts.web && (
                            <tr>
                                <td>{t('contacts.web')}</td>
                                <td className="contacts-popup-dialog--web"><a href={contacts.web}>{contacts.web}</a></td>
                            </tr>
                        )}
                    </tbody>
                </table>
                {contacts.other && (
                    <div className="contacts-popup-dialog--other">
                        {contacts.other.map(mapArrayToBreaks)}
                    </div>
                )}
            </div>
        </ModalDialog>
    );
}

export default ContactsPopup;
